export default __webpack_public_path__ + "static/media/u_bag-alt.38da3bbe.svg";